/* eslint-disable ember/no-new-mixins */
import Mixin from '@ember/object/mixin';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { getOwner } from '@ember/application';
import { service } from '@ember/service';
import Scopes from '@linc-technologies/linced-common/enums/scopes';

export default Mixin.create({
  reportingGroupBrowser: service(),
  permissions: service(),
  session: service(),

  canEditLeadershipComment: computed('session.scopes.[]', function () {
    return this.permissions.meet(Scopes.TENANT_ADMIN);
  }),

  parentController: computed(function () {
    return getOwner(this).lookup('controller:reporting');
  }),

  groupController: computed(function () {
    return getOwner(this).lookup('controller:reporting.group');
  }),

  controllerFor(name) {
    return getOwner(this).lookup('controller:' + name);
  },

  visibleGroups: alias('reportingGroupBrowser.visibleGroups'),
});
